import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "px-6 pt-2" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl mb-2 dark:text-white" }, "Order History", -1)
const _hoisted_4 = { class: "border border-black rounded-xl p-3" }
const _hoisted_5 = { class: "flex justify-between mb-3" }
const _hoisted_6 = { class: "dark:text-white" }
const _hoisted_7 = { class: "dark:text-white" }
const _hoisted_8 = { class: "grid grid-cols-2" }
const _hoisted_9 = { class: "flex ml-2" }
const _hoisted_10 = { class: "dark:text-blue-primary" }
const _hoisted_11 = {
  key: 0,
  class: "dark:text-blue-primary"
}
const _hoisted_12 = {
  key: 1,
  class: "dark:text-blue-primary"
}
const _hoisted_13 = {
  key: 2,
  class: "dark:text-blue-primary"
}
const _hoisted_14 = {
  key: 3,
  class: "dark:text-blue-primary"
}
const _hoisted_15 = { class: "dark:text-blue-primary" }
const _hoisted_16 = { class: "dark:text-blue-primary" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "py-2.5" }, null, -1)
const _hoisted_18 = { class: "grid grid-cols-2 items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "dark:text-green-primary ml-2" }, "Total", -1)
const _hoisted_20 = { class: "flex justify-between" }
const _hoisted_21 = { class: "dark:text-green-primary" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "text-center py-3" }
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, null, -1)
const _hoisted_26 = {
  key: 0,
  class: "dark:text-yellow-primary text-xs"
}

import { onMounted, ref  } from 'vue';

    interface addedItemType {
        name: string,
        cold: boolean | undefined,
        price: number,
        qty: number,
        total:number,
        temp?: boolean,
        bigPrice? :boolean | undefined,
    }

    interface history{
        saveOrders:addedItemType,
        timestamp:string,
        table:string,total:number
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryView',
  setup(__props) {

let savedOrders = ref<history[]>([]) 
    const fetchHistory = () =>{
        let item = localStorage.getItem('savedOrders')
        if(item!=null){
            savedOrders.value = JSON.parse(item).reverse()
        }
    } 
    onMounted(()=>{
        fetchHistory()
    })

    const deleteHistory = (index :number)=>{
        let item = localStorage.getItem('savedOrders')
        if(item!=null){
            let parsedItem :history[] = JSON.parse(item)
            parsedItem.splice(index,1)
            localStorage.setItem("savedOrders",JSON.stringify(parsedItem));
            fetchHistory()
        }
    }

    const deleteAllHistory = ()=>{
        localStorage.setItem("savedOrders",JSON.stringify([]));
        savedOrders.value=[]
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_unref(savedOrders).length>0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "text-red-primary font-semibold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteAllHistory()))
          }, "Delete All Histories"))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(savedOrders), (order, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, "Table " + _toDisplayString(order.table), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(order.timestamp), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.saveOrders, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1),
                  (item.cold!=undefined && item.cold)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "(冷)"))
                    : (item.cold!=undefined && !item.cold)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, "(热)"))
                      : _createCommentVNode("", true),
                  (item.bigPrice!=undefined && !item.bigPrice)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, "(小)"))
                    : (item.bigPrice!=undefined && item.bigPrice)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, "(大)"))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, "x" + _toDisplayString(item.qty), 1)
                ]),
                _createElementVNode("div", _hoisted_16, _toDisplayString(Math.round(item.total*100)/100), 1)
              ]),
              _hoisted_17
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(Math.round(order.total*100)/100), 1),
              _createElementVNode("button", {
                class: "text-red-primary font-semibold",
                onClick: ($event: any) => (deleteHistory(index))
              }, "Delete History", 8, _hoisted_22)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("a", {
              href: `/#/print/${index}`,
              target: "_blank",
              class: "dark:text-yellow-primary"
            }, "Print receipt", 8, _hoisted_24)
          ])
        ]),
        _hoisted_25
      ]))
    }), 128)),
    (_unref(savedOrders).length==0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, "No records found."))
      : _createCommentVNode("", true)
  ]))
}
}

})